import { createContext, useContext } from 'react';

import { ImsApi } from '@/api/ImsApi';

export const ImsApiContext = createContext<{
	imsApi: ImsApi;
	userId: string | null;
	imsToken: string | null;
	sessionDeadline: string | null;
	expireSession: () => void;
	deniedEmail: string | null;
	loading: boolean;
	// ISO country code of the signed-in Adobe account when it belongs to a
	// region where Beacon is not offered (anywhere outside the US and
	// Canada); null otherwise.
	blockedCountry: string | null;
	// Per-user feature-flag map (flag -> enabled), resolved from ui-proxy at login.
	// Optional; a missing flag reads as disabled (fail closed) via useFeatureFlag.
	featureFlags?: Record<string, boolean> | null;
} | null>(null);

export const useImsApiContext = () => useContext(ImsApiContext);
